const IMG = {
  website: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1600&q=80",
  shop: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1600&q=80",
  partner: "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?auto=format&fit=crop&w=1600&q=80",
  apps: "https://images.unsplash.com/photo-1651804805680-3565ef7807f6?auto=format&fit=crop&w=1600&q=80",
  marketing: "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&w=1600&q=80",
  retail: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1600&q=80",
  restaurant: "https://images.unsplash.com/photo-1621494548002-bfc916172ead?auto=format&fit=crop&w=1600&q=80",
  delivery: "https://images.unsplash.com/photo-1695654390723-479197a8c4a3?auto=format&fit=crop&w=1600&q=80",
  kitchen: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?auto=format&fit=crop&w=1600&q=80",
  table: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1600&q=80",
  seo: "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?auto=format&fit=crop&w=1600&q=80",
  menu: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1600&q=80",
  sms: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1600&q=80",
  analytics: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80",
  loyalty: "https://images.unsplash.com/photo-1607083206968-13611e3d76db?auto=format&fit=crop&w=1600&q=80",
};

const page = (slug, group, title, tagline, bullets, sections, related = []) => ({
  slug,
  group,
  title,
  tagline,
  bullets,
  sections,
  related,
});

const section = (heading, text, image = "") => ({ heading, text, image });

export const FEATURE_ALIASES = {
  "homepage-builder": "website",
  homepage: "website",
  "homepage-webshop": "website",
  "homepage-and-webshop": "website",
  webshop: "shop",
  "online-ordering": "shop",
  "online-ordering-systems": "shop",
  "owner-admin-app": "partner-app",
  "branded-mobile-apps": "customer-apps",
  "restaurant-mobile-app": "customer-apps",
  "marketing-campaigns": "marketing-tools",
  "restaurant-marketing-guide": "marketing-tools",
  "restaurant-email-marketing": "email-sms-marketing",
  "seo-for-restaurants": "seo-suite",
};

export const FEATURE_PAGES = {
  website: page(
    "website",
    "Product",
    "Website",
    "No-code. Drag & drop. Full control of a storefront that is actually yours.",
    [
      "No-code drag & drop page builder",
      "You have full control — no IT agency needed",
      "Add unlimited SEO-ready pages",
      "Meta titles, descriptions and keywords on every page",
      "Change texts, photos and banners yourself, anytime",
      "Your brand, your domain, your Google listing",
    ],
    [
      section("Your website, your rules", "Change texts, photos, banners and pages yourself — in minutes, without waiting for an agency. The drag & drop builder gives you full control over your storefront, and every page is SEO-ready out of the box so local customers actually find you.", IMG.website),
      section("Unlimited pages, zero code", "Need a catering page, a jobs page, a gallery or a seasonal landing page? Add as many pages as you want and arrange them with drag & drop. Publish instantly — no developer, no invoice, no waiting weeks for a headline change."),
      section("Found on Google", "Every page ships with clean structure, fast loading and full meta control — titles, descriptions and keywords per page. Your restaurant shows up when locals search, not buried under marketplace listings.", IMG.seo),
    ],
    ["shop", "seo-suite", "cms-content-pages"]
  ),
  shop: page(
    "shop",
    "Product",
    "The Shop",
    "A modern ordering experience like Just Eat and Uber Eats — but 100% yours, at 0% commission.",
    [
      "Integrated online payments via Swisspayout — including TWINT",
      "Vouchers and Buy-One-Get-One-Free offers",
      "Zip-code based pricing and delivery fees",
      "Category-based markup for delivery",
      "Different takeaway and delivery prices per item",
      "Combos, upsells and daypart menus",
    ],
    [
      section("Built to convert, priced your way", "Your customers order from a fast, modern shop that feels like the big platforms. You control the pricing per channel: set different takeaway and delivery prices, add zip-code delivery fees and apply category markups — automatically.", IMG.shop),
      section("Payments your customers trust", "Integrated online payments powered by Swisspayout — TWINT, cards, digital wallets and cash on pickup or delivery. Money goes straight to you, not through a marketplace."),
      section("Offers that sell more", "Run vouchers, discounts and Buy-One-Get-One-Free deals directly in your shop. Combine them with zone pricing so you protect margin on every single order.", IMG.loyalty),
    ],
    ["website", "delivery-zones", "combos-upsells"]
  ),
  "partner-app": page(
    "partner-app",
    "Product",
    "Partner App",
    "Your whole shop in your pocket — accept, print and control orders from an Android PDA or tablet.",
    [
      "Runs on Android PDA / tablet with a built-in printer",
      "Accept and print orders instantly",
      "Open or close the shop with one tap",
      "Vacation mode with an automatic customer message",
      "Live order hub from the kitchen or from home",
      "Complete shop control without a desktop",
    ],
    [
      section("Accept, print, control", "A new order prints automatically on your Android PDA or tablet. Accept, reject or delay with one tap, and the customer is informed instantly. No extra hardware and no fax-era workarounds.", IMG.partner),
      section("One tap opens or closes your shop", "Running late or fully booked? Pause delivery or close the shop in seconds — from the kitchen, from home, from anywhere. Every feature of your shop can be switched from the same app."),
      section("Vacation mode built in", "Set your holiday dates once and the shop pauses itself, with an automatic, friendly message to your customers. When you are back, everything switches on again. No support ticket needed.", IMG.kitchen),
    ],
    ["live-order-hub", "kitchen-printing", "customer-apps"]
  ),
  "customer-apps": page(
    "customer-apps",
    "Product",
    "Customer Apps",
    "Real native iOS and Android apps — your icon on their home screen, not a cheap webview.",
    [
      "Native iOS and Android apps, published under your brand",
      "Listed in the App Store and Google Play",
      "Saved addresses, favorites and one-tap re-ordering",
      "Push notifications for deals and order updates",
      "No PWA, no wrapped website, no marketplace next door",
      "Your direct channel — 0% commission",
    ],
    [
      section("Your icon on their home screen", "Customers download a real native app with your name, your logo and your colors. Fast, smooth and always one tap away — no browser, no marketplace, no competitors sitting next to your listing.", IMG.apps),
      section("Native means fast", "These are real iOS and Android apps, not a wrapped website. That means instant loading, reliable push notifications and an app-store presence that builds trust in your brand."),
      section("Ordering in three taps", "Saved addresses, favorite items and stored payment options make re-ordering effortless. Push notifications bring people back with flash deals and order updates — your channel, no commission attached.", IMG.sms),
    ],
    ["push-notifications", "loyalty-rewards", "marketing-tools"]
  ),
  "marketing-tools": page(
    "marketing-tools",
    "Product",
    "Marketing Tools",
    "Re-engage the customers you already earned — vouchers, BOGO, newsletters and SMS on autopilot.",
    [
      "Create offers and vouchers for your clients in seconds",
      "Buy-One-Get-One-Free deals with clear rules and dates",
      "Built-in newsletter and SMS campaigns",
      "Drag & drop campaign builder — made for owners, not agencies",
      "Automatic reminders for guests who have gone quiet",
      "Your list stays yours. The platforms never see it",
    ],
    [
      section("Marketing without an agency", "Launch a voucher, a BOGO deal or an SMS campaign in minutes with the drag & drop tool. Automatic reminders re-engage customers who have not ordered in a while — before the platforms win them back.", IMG.marketing),
      section("Vouchers and BOGO in minutes", "Percentage discounts, fixed-value vouchers, Buy-One-Get-One-Free — built for restaurant owners, not marketers. Set the rules, pick the dates, publish. Your customers see the offer in your shop and app instantly.", IMG.loyalty),
      section("Newsletters and SMS that bring them back", "Your customer list is yours — use it. Send newsletters and SMS campaigns from the built-in tool, and let automatic cart and visit reminders win back regulars while you focus on the kitchen.", IMG.sms),
      section("Own the relationship", "Marketplaces own the customer file. simplyOwner puts names, orders and consent in your system so you can talk to regulars without paying 30% for the privilege. That is the whole point of stopping the rent."),
    ],
    ["email-sms-marketing", "loyalty-rewards", "customer-apps"]
  ),
  "retail-stores": page(
    "retail-stores",
    "Industries",
    "Retail Stores",
    "Your products, your online shop, your margin — pickup and local delivery without a marketplace cut.",
    [
      "Sell your products online 24/7",
      "Pickup and local delivery built in",
      "TWINT, cards and wallets via Swisspayout",
      "Your brand, your domain, your customer data",
      "Opening hours, slots and zip-code fees",
    ],
    [
      section("From shelf to online in days", "Your assortment goes online with your branding and your domain. Customers order for pickup or local delivery, pay with TWINT or card, and you keep 100% of every sale.", IMG.retail),
      section("Built for local retail", "Opening hours, pickup slots, zip-code delivery fees and automatic order printing — the same engine that runs busy takeaways, adapted for shops. Manage everything from the partner app."),
      section("Customers you can actually reach again", "Every buyer lands in your list, not a platform inbox. Follow up with vouchers, SMS and a branded app so the next purchase does not start with a 30% fee.", IMG.marketing),
    ],
    ["shop", "delivery-zones", "sell-online"]
  ),
  "restaurants-pizzerias": page(
    "restaurants-pizzerias",
    "Industries",
    "Restaurants & Pizzerias",
    "Takeaway and delivery without the commission bite — menus, QR tables and kitchen printing included.",
    [
      "0% commission on every order",
      "Menu modifiers, sizes and toppings",
      "QR table ordering and reservations",
      "Kitchen printing and multi-location control",
      "Move regulars off Just Eat and Uber Eats",
    ],
    [
      section("Made for food businesses", "Sizes, toppings, cooking instructions, daypart menus and meal deals — the shop speaks kitchen. Customers order for pickup, delivery or straight from the table QR code.", IMG.restaurant),
      section("Your regulars, finally yours", "Stop paying 30% for people who already love you. Move them to your own shop and apps, then re-engage them with vouchers, push deals and SMS — all included.", IMG.table),
      section("Service that keeps up on Friday night", "Orders print in the kitchen, the partner app stays in your pocket, and vacation mode covers the weeks you close. The system is built for service, not for a marketplace HQ.", IMG.kitchen),
    ],
    ["shop", "qr-dine-in-reservations", "smart-online-menu"]
  ),
  "sell-online": page(
    "sell-online",
    "Industries",
    "Anyone Selling Online",
    "If you sell something, this system sells it — one-time price, no revenue share.",
    [
      "One-time price — no revenue share",
      "Website, shop, payments and apps included",
      "No-code control of everything",
      "Live in under 7 days",
      "Bakery, butcher, flowers, farm shop or fashion",
    ],
    [
      section("One system for any business", "Bakery, butcher, flower shop, farm store or fashion label — if customers buy from you, simplyOwner gives you the website, the shop, the payments and the apps to sell directly, without middlemen.", IMG.retail),
      section("Grow without permission", "Add pages, products, offers and locations whenever you want. The no-code builder and the partner app put every switch in your hands — no agency, no tickets, no commissions."),
      section("Keep what you earn", "Platforms tax growth. A one-time package and a small yearly running cost replace a forever cut of every basket. That is how owners stay owners.", IMG.shop),
    ],
    ["website", "shop", "retail-stores"]
  ),
  "seo-suite": page(
    "seo-suite",
    "Discovery",
    "SEO Suite",
    "Be found when locals search your food — not when they open a marketplace app.",
    [
      "Meta titles, descriptions and keywords on every page",
      "Clean URLs and fast, crawlable structure",
      "Landing pages for dishes, areas and occasions",
      "Your domain ranks — not a rented listing",
    ],
    [
      section("Search is cheaper than 30%", "Every marketplace click is rented. SEO pages you own keep working after you stop paying. simplyOwner ships structured pages so Google can actually understand your menu, hours and area.", IMG.seo),
      section("Pages that match how people search", "Create a pizza-in-your-town page, a catering page, a lunch deal page. The builder is SEO-ready: titles, descriptions and keywords sit next to the content, not in a developer ticket."),
      section("A storefront Google can trust", "Fast loading, mobile-first layout and a real domain beat a thin marketplace profile. Pair it with your own apps and the customer never has to come back through a platform.", IMG.website),
    ],
    ["website", "cms-content-pages", "marketing-tools"]
  ),
  "smart-online-menu": page(
    "smart-online-menu",
    "Discovery",
    "Smart Online Menu",
    "Modifiers, sizes, toppings and dayparts — a menu that sells the way your kitchen actually cooks.",
    [
      "Sizes, toppings and cooking instructions",
      "Meal combos, deals and category markups",
      "Daypart menus for lunch, dinner and late night",
      "Multi-language checkout for Swiss guests",
    ],
    [
      section("The menu is the product", "A PDF on Instagram does not take TWINT. A smart menu does: guests pick size, extra cheese, no onions, and pay. The ticket that hits the kitchen is the ticket they meant to order.", IMG.menu),
      section("Different prices for different channels", "Takeaway can be cheaper than delivery. A pizza category can carry a delivery markup. Zip codes can change the fee. You set the rules once; the shop applies them on every basket."),
      section("Change tonight's special in a tap", "Sold out? Hide the item. Friday grill? Switch the daypart. No agency, no waiting until Monday. The partner app and the website stay in sync.", IMG.restaurant),
    ],
    ["shop", "combos-upsells", "restaurants-pizzerias"]
  ),
  "cms-content-pages": page(
    "cms-content-pages",
    "Discovery",
    "CMS Content Pages",
    "Jobs, catering, galleries, seasonal stories — unlimited pages you publish yourself.",
    [
      "Unlimited pages beyond the shop",
      "Drag & drop sections and photos",
      "SEO fields on every page",
      "Publish instantly, edit anytime",
    ],
    [
      section("More than a menu URL", "A shop that only lists dishes loses the story. Add a team page, a wedding catering page, a weekend brunch landing page. Guests who land on those pages order from you, not from a grid of competitors.", IMG.website),
      section("Write it, publish it, own it", "The same no-code builder that runs the homepage runs every extra page. Swap a photo, change a price banner, add a German version — without opening a ticket."),
      section("Pages that work for search and for staff", "Each page can carry its own title and description. That is how a small restaurant ranks for 'catering Zurich' instead of renting that click from a platform.", IMG.seo),
    ],
    ["website", "seo-suite", "marketing-tools"]
  ),
  "email-sms-marketing": page(
    "email-sms-marketing",
    "Repeat orders",
    "Email & SMS Marketing",
    "Talk to your regulars directly — newsletters and SMS from the same system that takes the order.",
    [
      "Built-in newsletter tool",
      "SMS campaigns to opted-in guests",
      "Automatic quiet-customer reminders",
      "No extra marketing subscription required",
    ],
    [
      section("The list is the business", "Platforms will not hand you the phone numbers of people who already ordered your pizza twenty times. simplyOwner stores consent and contact details on your side so a Friday SMS is your Friday SMS.", IMG.sms),
      section("Write once, send to people who know you", "A short newsletter with this week's BOGO, a rain-day delivery reminder, a 'we missed you' note after three quiet weeks — built in, drag and drop, no agency login."),
      section("Reminders that run while you cook", "Automatic cart and visit reminders bring people back without you opening a campaign tool at midnight. Pair them with vouchers from Marketing Tools.", IMG.marketing),
    ],
    ["marketing-tools", "push-notifications", "loyalty-rewards"]
  ),
  "push-notifications": page(
    "push-notifications",
    "Repeat orders",
    "Push Notifications",
    "A tap on the lock screen — order updates and flash deals without a marketplace in the middle.",
    [
      "Native push on iOS and Android",
      "Order status without calling the shop",
      "Flash deals that land on the home screen",
      "Your channel, not a platform inbox",
    ],
    [
      section("The cheapest reminder in hospitality", "A push costs you nothing per send and does not sit next to three other restaurants. 'Your order is on the way' and 'double pepperoni until 8' both live in your app.", IMG.apps),
      section("Status they do not have to phone for", "Accepted, baking, out for delivery — guests stay off the line and you stay off the receiver. That is operations and marketing in the same tap."),
      section("Bring them back on a quiet Tuesday", "Target people who have the app and have not ordered this week. No 30% fee for the privilege of talking to your own regulars.", IMG.sms),
    ],
    ["customer-apps", "marketing-tools", "email-sms-marketing"]
  ),
  "loyalty-rewards": page(
    "loyalty-rewards",
    "Repeat orders",
    "Loyalty & Rewards",
    "Points, stamps and reasons to come back — so 80% of revenue stays with people you already know.",
    [
      "Automated points and rewards",
      "Promo codes and gift cards",
      "Offers visible in shop and app",
      "Built to keep regulars off the platforms",
    ],
    [
      section("Regulars already pay the rent", "Most hospitality revenue comes from people who have been before. Loyalty in simplyOwner lives in your shop and your apps, not in a marketplace stamp card you do not control.", IMG.loyalty),
      section("Rewards that do not leak margin to a platform", "A free drink after ten orders is cheaper than 30% on every order. Set the rules, publish, and let the shop apply them at checkout."),
      section("Gift cards and codes in the same toolkit", "Digital gift cards, promo codes and BOGO sit next to loyalty — one marketing drawer, not four subscriptions.", IMG.marketing),
    ],
    ["marketing-tools", "customer-apps", "shop"]
  ),
  "combos-upsells": page(
    "combos-upsells",
    "Sales",
    "Combos & Upsells",
    "Meal deals and add-ons that raise the basket — without training the guest on a marketplace UI.",
    [
      "Meal combos and set menus",
      "Suggested add-ons at checkout",
      "Category deals that protect margin",
      "Works on web shop and native apps",
    ],
    [
      section("The basket should work harder", "A pizza plus a drink plus garlic bread is how takeaway has always sold. Combos in simplyOwner make that the default path, on your shop and in your apps.", IMG.menu),
      section("Upsells that feel like hospitality", "Suggest a dessert or an extra topping without a dark pattern. You write the offer; the shop shows it before payment."),
      section("Deals you can switch off at 14:00", "Lunch combo until two, weekend family box, BOGO on a slow Monday — same engine as Marketing Tools, wired into the menu.", IMG.shop),
    ],
    ["smart-online-menu", "shop", "marketing-tools"]
  ),
  "delivery-zones": page(
    "delivery-zones",
    "Sales",
    "Delivery Zones",
    "Zip-code fees, radius rules and category markups — delivery priced like an owner, not like a platform.",
    [
      "Zip-code and radius-based fees",
      "Different prices for takeaway vs delivery",
      "Category markup on delivered items",
      "Hours, windows and holiday closures",
    ],
    [
      section("Distance has a cost. You set it.", "Farther zip codes can cost more. A sushi category can carry a delivery markup. Takeaway can stay cheaper. The guest sees the fee before they pay; you keep the margin.", IMG.delivery),
      section("Hours and holidays in one place", "Close delivery at 21:30, keep pickup open, pause a zone when a rider is off — from the partner app, without calling support."),
      section("Fulfillment that matches the kitchen", "Pickup flows, home delivery and order printing stay on the same ticket. Zones are pricing, not another product you have to stitch together.", IMG.kitchen),
    ],
    ["shop", "partner-app", "restaurants-pizzerias"]
  ),
  "qr-dine-in-reservations": page(
    "qr-dine-in-reservations",
    "Sales",
    "QR Dine-In & Reservations",
    "Guests order from the table and book a seat — without a third-party reservation tax.",
    [
      "Table QR self-ordering",
      "Online table reservations",
      "In-app and on-site promotion banners",
      "Tickets land in the same kitchen hub",
    ],
    [
      section("The table is a storefront", "A QR on the table opens your menu, not a generic ordering brand. Guests add a drink, pay with TWINT, and the ticket prints with the rest of the service.", IMG.table),
      section("Reservations you own", "Let people book a table from your site and app. The guest stays in your system — reminder SMS included — instead of another marketplace that rents you your own chair."),
      section("Promote what is on tonight", "Banners on the QR menu and in the app can push a wine, a dessert or a weekday lunch. Same marketing drawer as vouchers and SMS.", IMG.menu),
    ],
    ["restaurants-pizzerias", "shop", "live-order-hub"]
  ),
  "live-order-hub": page(
    "live-order-hub",
    "Operations",
    "Live Order Hub",
    "Every channel in one board — web, app, QR — accept, delay or reject without juggling tablets.",
    [
      "Real-time orders from shop, apps and QR",
      "Accept, delay or reject with guest updates",
      "Kitchen printing on the same ticket",
      "Works with the partner app in your pocket",
    ],
    [
      section("One board, not four tablets", "Marketplace tablets fight for counter space and attention. simplyOwner puts website, app and QR orders on one live hub so Friday night has one source of truth.", IMG.partner),
      section("The guest hears the decision", "Accept, delay or reject and the customer is told immediately — in the app, by SMS or on the confirmation page. Fewer 'where is my food' calls."),
      section("From the pass or from the tram", "The same hub lives in the partner app. A second location or a manager on the move still sees what the kitchen sees.", IMG.analytics),
    ],
    ["partner-app", "kitchen-printing", "multi-store-control"]
  ),
  "kitchen-printing": page(
    "kitchen-printing",
    "Operations",
    "Kitchen Printing",
    "Tickets on paper when the ticket matters — automatic print from the PDA or a kitchen printer.",
    [
      "Automatic print on new orders",
      "Android PDA with built-in printer",
      "Clear modifiers, sizes and notes",
      "No fax, no marketplace docket chaos",
    ],
    [
      section("If it is not printed, it is not an order", "The kitchen still runs on paper in most busy rooms. simplyOwner prints as soon as you accept — toppings, notes and channel included.", IMG.kitchen),
      section("Hardware you already understand", "An Android PDA with a built-in printer covers the pass. No extra 'partner tablet' from a platform that also takes 30%."),
      section("One ticket language", "Web, app and QR orders look the same on the docket. Staff do not re-learn a UI every time a marketplace updates its app.", IMG.partner),
    ],
    ["partner-app", "live-order-hub", "smart-online-menu"]
  ),
  "sales-analytics": page(
    "sales-analytics",
    "Operations",
    "Sales Analytics",
    "See what sold, when, and through which channel — without exporting a marketplace CSV.",
    [
      "Channel and daypart views",
      "Bestsellers and quiet items",
      "Delivery vs pickup split",
      "Numbers you can act on the same night",
    ],
    [
      section("Your numbers, not a platform dashboard", "Marketplaces show you just enough to keep advertising. simplyOwner shows orders you actually own — by channel, hour and item — because the data never left your system.", IMG.analytics),
      section("Decide tonight, not next quarter", "If Tuesday lunch is quiet, push a combo. If one pizza carries the week, put it on the homepage. Analytics sit next to Marketing Tools on purpose."),
      section("Multi-store without a spreadsheet", "Compare locations without merging three marketplace exports. Pair with Multi-Store Control when you grow.", IMG.retail),
    ],
    ["multi-store-control", "marketing-tools", "live-order-hub"]
  ),
  "multi-store-control": page(
    "multi-store-control",
    "Operations",
    "Multi-Store Control",
    "Several addresses, one owner login — menus, hours and orders per location.",
    [
      "Multiple locations under one account",
      "Per-store hours, zones and menus",
      "Shared brand, local operations",
      "Partner app per site",
    ],
    [
      section("Grow the brand, not the chaos", "A second pizzeria should not mean a second marketplace contract and a second 30%. simplyOwner keeps the brand together and the kitchens independent.", IMG.retail),
      section("Local rules, shared customers", "Hours, delivery zones and menus can differ per shop. Loyalty and apps can still carry the same brand so regulars recognize you in the next neighbourhood."),
      section("One owner view", "See orders and performance per location without logging into three partner portals. That is what owning the stack looks like when you scale.", IMG.analytics),
    ],
    ["sales-analytics", "partner-app", "live-order-hub"]
  ),
  "case-studies": page(
    "case-studies",
    "Resources",
    "Case Studies",
    "What changes when the commission stops — owners who moved regulars onto their own shop and apps.",
    [
      "0% commission on every direct order",
      "One-time package instead of a forever cut",
      "Live in under 7 days",
      "Swiss payments including TWINT",
    ],
    [
      section("The proof is in the margin", "A shop doing 2'000 platform orders a month at 30% and CHF 35 a basket is handing over about CHF 21'000 every month. That is not marketing. That is rent. simplyOwner replaces that rent with a one-time system.", IMG.analytics),
      section("Regulars already chose you", "The guests who order every Friday do not need a marketplace to find you. They need a shop, an app and a reason to stay. Case after case, the win is moving that habit off the platform."),
      section("See your own number", "Use the savings calculator with your order volume and commission. Then book a 30-minute demo and watch the same shop, with your menu, take a TWINT payment.", IMG.shop),
    ],
    ["marketing-tools", "restaurants-pizzerias", "shop"]
  ),
};

export const FEATURE_GROUPS = [
  { title: "The Product", slugs: ["website", "shop", "partner-app", "customer-apps", "marketing-tools"] },
  { title: "Target Industries", slugs: ["restaurants-pizzerias", "retail-stores", "sell-online"] },
  { title: "Grow discovery", slugs: ["seo-suite", "smart-online-menu", "cms-content-pages"] },
  { title: "Grow repeat orders", slugs: ["email-sms-marketing", "push-notifications", "loyalty-rewards"] },
  { title: "Grow online sales", slugs: ["combos-upsells", "delivery-zones", "qr-dine-in-reservations"] },
  { title: "Run your restaurant", slugs: ["live-order-hub", "kitchen-printing", "sales-analytics", "multi-store-control"] },
  { title: "Resources", slugs: ["case-studies"] },
];

export const FOOTER_FEATURE_HREFS = {
  "Homepage & Webshop": "/features/website",
  "SEO Suite": "/features/seo-suite",
  "Smart Online Menu": "/features/smart-online-menu",
  "CMS Content Pages": "/features/cms-content-pages",
  "Branded Mobile Apps": "/features/customer-apps",
  "Marketing Campaigns": "/features/marketing-tools",
  "Email & SMS Marketing": "/features/email-sms-marketing",
  "Push Notifications": "/features/push-notifications",
  "Loyalty & Rewards": "/features/loyalty-rewards",
  "Online Ordering": "/features/shop",
  "Combos & Upsells": "/features/combos-upsells",
  "Delivery Zones": "/features/delivery-zones",
  "QR Dine-In & Reservations": "/features/qr-dine-in-reservations",
  "Owner Admin App": "/features/partner-app",
  "Live Order Hub": "/features/live-order-hub",
  "Kitchen Printing": "/features/kitchen-printing",
  "Sales Analytics": "/features/sales-analytics",
  "Multi-Store Control": "/features/multi-store-control",
  "Case Studies": "/features/case-studies",
  "Restaurant Marketing Guide": "/features/marketing-tools",
  "SEO for Restaurants": "/features/seo-suite",
  "Restaurant Email Marketing": "/features/email-sms-marketing",
  "Restaurant Mobile App": "/features/customer-apps",
  "Online Ordering Systems": "/features/shop",
};

export function normalizeFeatureSlug(raw) {
  return String(raw || "")
    .trim()
    .replace(/\/+$/, "")
    .toLowerCase();
}

export function resolveFeatureSlug(raw) {
  const slug = normalizeFeatureSlug(raw);
  return FEATURE_ALIASES[slug] || slug;
}

export function getFeaturePage(raw) {
  const slug = resolveFeatureSlug(raw);
  return FEATURE_PAGES[slug] || null;
}

export function listFeaturePages() {
  return FEATURE_GROUPS.flatMap((group) =>
    group.slugs.map((slug) => FEATURE_PAGES[slug]).filter(Boolean)
  );
}

export function featureHref(slug) {
  return `/features/${resolveFeatureSlug(slug)}`;
}

export function mergeFeaturePage(local, remote) {
  if (!local) return remote || null;
  if (!remote) return local;
  const remoteSections = Array.isArray(remote.sections) ? remote.sections : [];
  const localSections = local.sections || [];
  const count = Math.max(localSections.length, remoteSections.length);
  const sections = Array.from({ length: count }, (_, i) => {
    const l = localSections[i] || { heading: "", text: "", image: "" };
    const r = remoteSections[i] || {};
    return {
      heading: (r.heading && String(r.heading).trim()) || l.heading,
      text: (r.text && String(r.text).trim()) || l.text,
      image: (r.image && String(r.image).trim()) || l.image || "",
    };
  });
  return {
    ...local,
    title: (remote.title && String(remote.title).trim()) || local.title,
    tagline: (remote.tagline && String(remote.tagline).trim()) || local.tagline,
    bullets: remote.bullets?.length ? remote.bullets : local.bullets,
    sections,
  };
}
